import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConnectedRouter } from 'connected-react18-router';
import { Web3ReactProvider, initializeConnector } from '@web3-react/core';
import { MetaMask } from '@web3-react/metamask';
import history from 'utils/history';
import 'react-18-image-lightbox/style.css';
import 'sanitize.css/sanitize.css';

// Import root app
import App from 'containers/App';
import './styles/layout/base.scss';

// Import Language Provider
import LanguageProvider from 'containers/LanguageProvider';

import configureStore from './redux/configureStore';
import { translationMessages } from './i18n';

// Initialize MetaMask connector
const [metaMask, hooks] = initializeConnector(
    (actions) => new MetaMask({ actions })
);

// Create redux store with history
const initialState = {};
const { store, persistor } = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById('app');

const root = createRoot(MOUNT_NODE);

// 서버 요청으로 api 테스트를 위해 코드 이식
window.CallApiTest = function (url, data) {
  function getCookie(name) {
    const cookieValue = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return cookieValue ? cookieValue[2] : null;
  }
  const check = /prod/i.test(document.domain) ? '' : '.test';
  const domain = `https://backoffice.service${check}.perplay.io/api`;
  const headerData = {
    AccessToken: decodeURIComponent(getCookie('token')),
    'CF-Access-Client-Id': '4210cff703e83401a76ff3cf83304054.access',
    'CF-Access-Client-Secret': '2487d06c0681e7b76d59427be09e21473f987a4d11970ae2dd85d6cd1d2bd825',
    'Content-Type': 'application/json',
    accept: 'text/plain'
  };
  const method = data ? 'POST' : 'GET';
  const body = data ? JSON.stringify(data) : null;
  const options = {
    method: method,
    headers: headerData,
  };
  if (body) {
    options.body = body;
  }
  fetch(`${domain}/${url}`, options)
      .then(response => response.json())
      .then(data => { console.log(data); })
      .catch(error => { console.error('Error:', error); });
};

const render = messages => {
  root.render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Web3ReactProvider connectors={[[metaMask, hooks]]}>
            <LanguageProvider messages={messages}>
              <ConnectedRouter history={history}>
                <App history={history} />
              </ConnectedRouter>
            </LanguageProvider>
          </Web3ReactProvider>
        </PersistGate>
      </Provider>
  );
};

if (module.hot) {
  module.hot.accept(['./i18n', 'containers/App'], () => {
    render(translationMessages);
  });
}

if (!window.Intl) {
  new Promise(resolve => {
    resolve(import('intl'));
  })
      .then(() => Promise.all([
        import('intl/locale-data/jsonp/en.js'),
        import('intl/locale-data/jsonp/de.js'),
      ]))
      .then(() => render(translationMessages))
      .catch(err => {
        throw err;
      });
} else {
  render(translationMessages);
}